var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activities-priority-icon-button" },
    [
      _c(
        "CompassTooltip",
        {
          attrs: {
            arrow: false,
            content: _vm.tooltipContent,
            contentClass: _vm.tooltipContentClass,
            placement: "bottom-start"
          }
        },
        [
          _c("CompassIconButton", {
            class: _vm.iconClass,
            attrs: {
              size: _vm.size,
              icon: _vm.icon,
              loading: _vm.isPending,
              "data-bot": _vm.dataBot,
              disabled: !_vm.enabled
            },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.updatePriority($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }